/* eslint-disable default-case */
import React, { useContext, useReducer, createContext, useEffect, useState } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import produce from 'immer';
import createPersistedState from 'use-persisted-state';
import { Slate } from 'slate-react';

import { Tabs } from 'app-constants';
import { arrayToObject } from 'utils';
import { getSession } from 'api/actions/auth';
import { fetcher } from 'api/client';
import { fetchProfile } from 'api/actions/profile';
import { fetchClientContract, clientContractAction } from 'api/actions/contracts';
import { useConstant } from 'hooks/useConstant';
import { getEditorInstance } from 'components/Editor/Canvas/TratoFormat';
import { useFingerPrint } from 'hooks/useFingerprint';
const SignStateContext = createContext();
const SignDispatchContext = createContext();

export const SET_PROFILE = 'SET_PROFILE';
export const SET_JWT = 'SET_JWT';
export const RESET = 'RESET';
export const SET_CONTRACT = 'SET_CONTRACT';
export const REQUEST_AGREEMENT = 'REQUEST_AGREEMENT';
export const SET_WARNING_MESSAGE = 'SHOW_NOT_INVOLVED';
export const TOGGLE_COMMENTS = 'TOGGLE_COMMENTS';
export const SET_PASSWORD = 'SET_PASSWORD';
export const CHANGE_TAB = 'CHANGE_TAB';
export const OPEN_COMMENTS = 'OPEN_COMMENTS';
export const SET_SIGNATURE_CONFIRMATIONS = 'SET_SIGNATURE_CONFIRMATIONS';
export const HIGHTLIGHT_MISSING_CHECKS = 'HIGHTLIGHT_MISSING_CHECKS';
export const HIGHTLIGHT_MISSING_COMPLETE = 'HIGHTLIGHT_MISSING_COMPLETE';
export const SET_MISSING_VARS = 'SET_MISSING_VARS'
export const CONTROL_WAITER = 'CONTROL_WAITER';
export const CHANGE_PREVIEW = 'CHANGE_PREVIEW';
export const CONTROL_OPEN_TOUR = 'CONTROL_OPEN_TOUR';
export const CONTROL_MODAL = 'CONTROL_MODAL';
export const CONTROL_CHAT = 'CONTROL_CHAT'
export const TOGGLE_ACTIVE_NAV = 'TOGGLE_ACTIVE_NAV';
export const SET_ELEMENTS = 'SET_ELEMENTS';
export const CHANGE_ELEMENT_VERSION = 'CHANGE_ELEMENT_VERSION';
export const SET_PDF_META = 'SET_PDF_META';
export const ZOOM_VIDEO_CHAT_MODAL = 'ZOOM_VIDEO_CHAT_MODAL';
export const ZOOM_UPLOAD_VIDEO_MODAL = 'ZOOM_UPLOAD_VIDEO_MODAL';

export const VIDEO_CHAT_MODAL = 'VIDEO_CHAT_MODAL';
export const CONFIRM_UPLOAD_MODAL = 'CONFIRM_UPLOAD_MODAL';
export const SHARE_MODAL = 'SHARE_MODAL';
export const SIGN_MODAL = 'SIGN_MODAL';
export const TUTORIAL_MODAL = 'TUTORIAL_MODAL';
export const CHAT_MODAL = 'CHAT_MODAL';
export const PRIVACY_MODAL = 'PRIVACY_MODAL';
export const SIGNUP_MODAL = 'SIGNUP_MODAL';
export const FIEL_MODAL = 'FIEL_MODAL';
export const PARTICIPANT_MODAL = 'PARTICIPANT_MODAL';
export const SHIELD3_MODAL = 'SHIELD3_MODAL';
export const VERIDOC_MODAL = 'VERIDOC_MODAL';
export const ONETIME_PASSWORD_MODAL = 'ONETIME_PASSWORD_MODAL';
export const LOGIN_MODAL = 'LOGIN_MODAL';
export const NEGOTIATE_SIGN_MODAL = 'NEGOTIATE_SIGN_MODAL';
export const PHONE_MODAL = 'PHONE_MODAL';
export const BLOCKCHAIN_MODAL = 'BLOCKCHAIN_MODAL';
export const INE_MODAL = 'INE_MODAL';

const initialState = () => ({
    modal: [],
    tab: '',
    showWaiter: false,
    isLoading: true,
    authenticated: false,
    chatOpen: false,
    contractId: null,
    warningMessage: null,
    password: null,
    openComments: false,
    commentElementId: null,
    onlyIne: false,
    missingVars: [],
    signatureConfirmations: {},
    currentVersions: [],
    missingSignatureConfirmations: 0,
    totalSignatureConfirmations: 0,
    focused: null,
    attachmentsMissing: [],
    tutorialScreens: [],
    variablesMissing: [],
    touchedVars: false,
    previewUrl: null,
    previewMode: false,
    pdfMeta: {
        totalPages: 0,
        currentPage: 1
    },
    blurMain: false,
    isTourOpen: false,
    tourStartAt: 0,
    contract: {},
    profile: {},
    activeNav: false,
    jwt: null,
    tabs: []
})

const reducer = produce((draft, action) => {
    switch (action.type) {
        case CONTROL_CHAT:
            draft.chatOpen = action.open
            break;
        case CONTROL_MODAL:
            draft.modal = [action.open];
            if (action.close) draft.modal = draft.modal.filter(m => m === action.close);
            draft.wordonline = action.wordonline || {};
            draft.onlyIne = action.onlyIne || false;
            draft.blurMain = action.blurMain;
            draft.participantId = action.participantId;
            break;
        case CONTROL_OPEN_TOUR:
            draft.isTourOpen = action.open;
            draft.tourStartAt = action.tourStartAt;
            break;

        case CONTROL_WAITER:
            draft.showWaiter = action.open;
            // draft.blurMain = action.open;
            break;
        case SET_MISSING_VARS:
            draft.variablesMissing.forEach((v) => {
                if (v._id === action.variableId || v.apiName === action.apiName) {
                    v.apiName = action.apiName;
                    v.value = action.value;
                    draft.touchedVars = true;
                }
            })
            break;
        case HIGHTLIGHT_MISSING_COMPLETE:
            // console.log(draft.attachmentsMissing?.[0]?._id)
            // console.log(draft.variablesMissing?.[0].apiName)
            break;

        case SET_SIGNATURE_CONFIRMATIONS:
            draft.signatureConfirmations[action.signatureConfirmation] = !draft.signatureConfirmations[action.signatureConfirmation] ? new Date() : false;
            draft.missingSignatureConfirmations = Object.keys(draft.signatureConfirmations).map(x => draft.signatureConfirmations[x]).filter(p => p).length;
            draft.totalSignatureConfirmations = Object.keys(draft.signatureConfirmations).length;
            break;

        case TOGGLE_COMMENTS:
            draft.openComments = !draft.openComments;
            break;
        case OPEN_COMMENTS:
            draft.openComments = action.open;
            draft.commentElementId = action.commentElementId;
            break;
        case CHANGE_TAB:
            draft.tab = action.tab;
            break;
        case SET_PASSWORD:
            draft.password = action.password;
            draft.warningMessage = null;
            break;
        case SET_WARNING_MESSAGE:
            draft.warningMessage = action.warningMessage;
            draft.warningMessageProps = action.warningMessageProps;
            draft.isLoading = false;
            draft.contractId = action.contractId;
            break;
        case REQUEST_AGREEMENT:
            draft.modal = [PRIVACY_MODAL];
            draft.isLoading = false;
            draft.contractId = action.contractId;
            draft.blurMain = true;
            break;
        case HIGHTLIGHT_MISSING_CHECKS:
            draft.focused = Object.keys(draft.signatureConfirmations).find(x => !draft.signatureConfirmations[x]);
            document.getElementById(`signature-check-input-${draft.focused}`)?.focus();
            break;
        case CHANGE_PREVIEW:
            draft.previewUrl = action.previewUrl;
            draft.previewMode = action.previewMode;
            draft.isNom = action.isNom;
            draft.isRfc3161 = action.isRfc3161;
            break;
        case SET_CONTRACT:
            draft.warningMessage = null;
            draft.isLoading = action.isLoading;
            draft.contractId = action.contractId;
            draft.signatureConfirmations = draft.totalSignatureConfirmations ? draft.signatureConfirmations : action.signatureConfirmations;
            draft.totalSignatureConfirmations = Object.keys(draft.signatureConfirmations).length;
            draft.attachmentsMissing = action.attachmentsMissing || [];
            draft.variablesMissing = draft.touchedVars ? draft.variablesMissing : action.variablesMissing || [];
            draft.showSignUpModal = action.showInvite ? draft.modal = [SIGNUP_MODAL] : null;
            draft.email = action.email;
            draft.previewUrl = draft.previewUrl || action.previewUrl;
            draft.shield3Statement = action.shield3Statement;
            draft.requestLocation = action.requestLocation;
            draft.showMetamask = action.showMetamask;
            draft.tutorialScreens = action.tutorialScreens || [];
            draft.contract = action.contract;
            draft.tabs = action.tabs;
            draft.tab = draft.tabs.find(t => t.name === draft.tab)?.name || draft.tabs?.[0]?.name;
            break;
        case TOGGLE_ACTIVE_NAV:
            draft.activeNav = !draft.activeNav;
            break;
        case SET_PROFILE:
            draft.profile = action.profile;
            break;
        case SET_JWT:
            draft.jwt = action.jwt;
            break;
        case SET_ELEMENTS:
            draft.contract.elements = action.elements;
            break;
        case SET_PDF_META:
            draft.pdfMeta = {
                ...draft.pdfMeta,
                ...action.pdfMeta
            };
            break;
        case CHANGE_ELEMENT_VERSION:
            const [firstPath, ...path] = action.elementPath;
            let element = draft.contract.elements[firstPath];


            if (path?.length > 0) {
                element = element.children;
                path.map((p, i) => {
                    if (path.length === i + 1) {
                        element = element[p]
                    } else {
                        element = element[p].children;
                    }
                })
            }

            element.children = action.version.children;
            element.currentVersionId = action.version._id;
            element.currentVersionIndex = element.versions.findIndex(version => version._id === action.version._id);
            break;
        case RESET:
            draft = initialState();
            break;
    }
}, {});

const showTabs = (contract) => {
    return [
        {
            name: 'negotiation_tab',
            shouldShow: contract.signViewOptions?.showNegotiation,
        },
        {
            name: 'complete_tab',
            shouldShow: contract.signViewOptions?.showComplete,
        },
        {
            name: 'annexes_tab',
            shouldShow: contract.signViewOptions?.showAttachments && !contract.signViewOptions?.showComplete,
        },
        {
            name: 'sharedocs_tab',
            shouldShow: contract.signViewOptions?.showShare,
        },
        {
            name: 'blockchain_tab',
            shouldShow: contract.signViewOptions?.showBlockchain,
        },
        {
            name: 'pagare_tab',
            shouldShow: contract.isPagare,
        },
        {
            name: 'related_tab',
            shouldShow:
                contract.signViewOptions?.relatedContracts?.parent?.participants?.length ||
                contract.signViewOptions?.relatedContracts?.references?.length
        }
    ].filter(s => s.shouldShow)
}

function getSignatureConfirmations(data) {
    return data.importedPdf && data.status === 'SENT_TO_SIGN' ?
        arrayToObject(data.signViewOptions?.currentParticipant?.signatures, '_id', false)
        : arrayToObject(data.elements.filter(e => e.type === 'signature'), '_id', false)
}

function SignProvider({ children }) {
    const { i18n } = useTranslation();
    const { uuid, contractId } = useParams();
    const { search, pathname } = useLocation();
    const history = useHistory();
    const [state, dispatch] = useReducer(reducer, initialState());
    const editor = useConstant(() => getEditorInstance({}))
    const { isLoading: isFingerprintLoading, fingerprint } = useFingerPrint();


    const { mutate: getUserAsParticipantMutation } = useMutation(() =>
        fetcher(clientContractAction(contractId, 'getUserAsParticipant', {})), {
        onSuccess: (payload) => {
            if (payload?.jwt) {
                history.push(`/sign/${contractId}/${payload.jwt}`)
            } else {
                dispatch({ type: SET_JWT, jwt: localStorage.getItem('jwt') });
            }
        }
    })

    const { mutate: getSessionMutation } = useMutation((payload) => fetcher(getSession(payload)), {
        onSuccess: (session) => {
            dispatch({ type: SET_JWT, jwt: session.jwt })
        }
    })

    useQuery(['client-profile', uuid], () =>
        fetcher(fetchProfile(contractId), { jwt: state.jwt }), {
        enabled: !!state.jwt,
        refetchOnWindowFocus: false,
        onSuccess: (profile) => {
            dispatch({ type: SET_PROFILE, profile });
        }
    })

    useQuery(['client-contract', contractId, state.jwt, state.password],
        () => fetcher(fetchClientContract(contractId, state?.password, fingerprint.visitorId), { jwt: state.jwt }),
        {
            enabled: !!state.profile._id,
            onSuccess: (data) => {
                const warningMessage = data.message;
                if (warningMessage) {
                    if (warningMessage === 'hasToAcceptPrivacyAgreement') {
                        dispatch({ type: REQUEST_AGREEMENT, contractId })
                    }
                    else if (warningMessage === 'isPasswordProtected') {
                        dispatch({ type: SET_WARNING_MESSAGE, contractId, warningMessage })
                    } else {
                        dispatch({ type: SET_WARNING_MESSAGE, contractId, warningMessage, warningMessageProps: data })
                    }
                } else {
                    dispatch({
                        type: SET_CONTRACT,
                        warningMessage: null,
                        contract: data,
                        contractId: data._id,
                        isLoading: false,
                        tabs: showTabs(data),
                        signatureConfirmations: data.signCheckConfirmation ? getSignatureConfirmations(data) : {},
                        attachmentsMissing:
                            data.signViewOptions?.currentParticipant?.attachmentsMissing || [],
                        variablesMissing:
                            data.signViewOptions?.currentParticipant?.variablesMissing || [],
                        showInvite: data.signViewOptions?.showInvite,
                        email: data.signViewOptions?.currentParticipant?.email,
                        previewUrl: data.importedPdf,
                        shield3Statement: data.signViewOptions?.shield3Statement,
                        requestLocation: data.signViewOptions?.currentParticipant?.requestLocation,
                        showMetamask: data.signViewOptions?.showMetamask || data.isPagare,
                        // tutorialScreens: [
                        //     data.isPagare && SCREEN_OPTIONS.PAGARE_TUTORIAL,
                        //     data.signViewOptions?.showShare && SCREEN_OPTIONS.CONFIDENTIAL_ATTACHMENTS_TUTORIAL
                        //     // UPLOAD_DOWNLOAD_VERSION_TUTORIAL
                        //     // NEGOTIATE_OR_SIGN_TUTORIAL
                        //     // SIGN_TUTORIAL
                        // ].filter(t => t)
                    })
                }
            },
            onError: (error) => {
                dispatch({ type: SET_WARNING_MESSAGE, contractId, warningMessage: error.message })
            },
            onSettled: () => {
            }
        })

    useEffect(() => {
        const params = new URLSearchParams(search);
        const lang = params.get('lang');

        if (lang) {
            i18n.changeLanguage(lang.toLowerCase())
        }

        if (uuid) {
            getSessionMutation({ uuid, contractId })
        } else if (localStorage.getItem('jwt')) {
            getUserAsParticipantMutation()
        } else {
            history.push('/login', { from: pathname });
        }
    }, [uuid, contractId, search])

    const handleChange = (value) => {
        dispatch({ type: SET_ELEMENTS, elements: value })
    }

    console.log({fingerprint})

    return (
        <Slate editor={editor} value={state.contract.elements} onChange={handleChange}>
            <SignStateContext.Provider value={{ ...state, isLoading: isFingerprintLoading || state.isLoading , fingerprint }}>
                <SignDispatchContext.Provider value={dispatch}>
                    {children}
                </SignDispatchContext.Provider>
            </SignStateContext.Provider>
        </Slate>
    )
}

function useSignState() {
    const context = useContext(SignStateContext)
    if (context === undefined) {
        throw new Error('useSignState must be used within a SignProvider')
    }
    return context
}

function useSignDispatch() {
    const context = useContext(SignDispatchContext)
    if (context === undefined) {
        throw new Error('useSignDispatch must be used within a SignProvider')
    }
    return context
}


function useSign() {
    return [useSignState(), useSignDispatch()]
}

export { SignProvider, useSign, useSignState, useSignDispatch }
